<template>
  <v-container fluid class="py-3" v-bind:class="{ 'red darken-1': alert }">
    <v-layout wrap justify-center fill-height>
      <v-flex xs12>
        <v-subheader class="title">Selecciona su plan de comida</v-subheader>
      </v-flex>
      <v-flex xs12 v-if="loading">
        <v-card-text>
          <p class="text-xs-center">
            Buscando comidas para la habitación.
          </p>
          <v-progress-linear indeterminate color="red" class="mb-0" height="1"></v-progress-linear>
        </v-card-text>
      </v-flex>
      <v-flex xs12 v-else class="pt-0">
        <v-chip label color="orange darken-1" text-color="white" v-if="obligatorio">
          Las comidas para esta habitación son obligatorios
        </v-chip>
        <v-chip color="green" text-color="white" v-if="comidaSeleccionada.mostrar" class="text-capitalize">
          <v-avatar class="green darken-4"><v-icon class="caption">fas fa-check</v-icon></v-avatar>
          {{ comidaSeleccionada.comida.nombre.toLowerCase() }}
        </v-chip>
      </v-flex>
      <v-flex xs12 v-if="data">
        <v-container fluid class="py-0">
          <v-layout wrap justify-space-around>
            <v-flex xs12 sm3 v-for="(p, idc) in toArray(data.planes.plan)" :key="`comidas-${idc}`">
              <PanelComida :comida="p" :comparador="comparador" :data-cy="`panelComida-${comparador}`"></PanelComida>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PanelComida from "@/components/comidas/PanelComida.vue"
export default {
  name: "contenedorComidasHoteles",
  props: {
    /*  data: {
                type: Object,
                default: function () {
                    return {planes: {plan: []}};
                }
            },*/
    loading: {
      type: Boolean,
      default: function() {
        return true
      }
    },
    comparador: {
      type: String,
      default: function() {
        return null
      }
    },
    obligatorio: {
      type: Boolean,
      default: false
    },
    alert: {
      type: Boolean,
      default: false
    },
    comidasHabitacion: {
      type: Array,
      default: function() {
        return []
      }
    },
    allComidas: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  components: {
    PanelComida
  },
  mounted() {},
  beforeCreate() {},
  methods: {},
  data() {
    return {
      data: { planes: { plan: [] } }
    }
  },
  computed: {
    comidaSeleccionada: function() {
      if (this.comidasHabitacion.length > 0) {
        return { mostrar: true, comida: this.comidasHabitacion[0] }
      }
      return { mostrar: false }
    }
  },
  watch: {
    allComidas: function() {
      // watch it
      this.data = this.allComidas.find(a => a.comparador === this.comparador)
    }
  }
}
</script>
